<i18n>
{
  "fr": {
    "Title": "Rapport de vélocité de tout le monde",
    "Velocity": "Vélocité",
    "DisplayName": "Nom",
    "ProjectsInError": "Projets en erreur"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title')" />
    <AppContainer>
      <table class="table table-bordered table-hover">
        <thead class="thead-dark">
          <tr>
            <th
              v-t="'DisplayName'"
              scope="col"/>
            <th
              v-t="'Velocity'"
              scope="col"/>
            <th
              v-t="'ProjectsInError'"
              scope="col"/>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in usersVelocity"
            :key="user.userId">
            <td scope="row">{{ user.displayName }}</td>
            <td
              :class="{
                'bg-primary': user.velocity <= 1 && user.velocity >= 0.95,
                'bg-success': user.velocity < 0.95 && user.velocity >= 0.90,
                'bg-warning': user.velocity < 0.90 && user.velocity >= 0.85,
                'bg-danger': user.velocity < 0.85,
              }"
            >{{ user.velocity | percentage }}</td>
            <td
              :class="{ 'bg-danger-light': user.projectsInError > 0 }"
            >{{ user.projectsInError }}</td>
          </tr>
        </tbody>
      </table>
    </AppContainer>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('tasks', ['usersVelocity']),
  },
  created() {
    this.$store.dispatch('tasks/getAllVelocity', this.$route.query);
  },
};
</script>
